import React, { useEffect, useState } from 'react';
import ProductGrid from '../components/ProductGrid';
import { getProducts } from '../api/apiendpoint';
import { useCart } from '../context/CartContext';

const Products = () => {
  const [products, setProducts] = useState([]);
  const { addToCart } = useCart();

  useEffect(() => {
    const loadProducts = async () => {
      const data = await getProducts();
  
      const formatted = data.map(p => ({
        id: p.id,
        name: p.product_name || 'Unnamed Product',
        image: p.images.length > 0
          ? `https://mysite-dtzs.onrender.com${p.images[0].product_img}`
          : 'https://via.placeholder.com/300x250?text=No+Image',
        originalPrice: parseFloat(p.product_price) || 0,
        discountedPrice: parseFloat(p.product_price_discount) || 0,
        price: parseFloat(p.product_price_discount) || 0, // used for cart
        description: p.product_discription || 'No description available.',
      }));
  
      setProducts(formatted.slice(0, 4)); // limit to 4 products
    };
  
    loadProducts();
  }, []);
  return (
    <div className="px-4 py-6">
   
     <h1 className="display-5 text-center mb-4">Popular Products</h1>
      <ProductGrid products={products} addToCart={addToCart} />
    </div>
  );
};

export default Products;
